/*
  OSMODI home page v8, draft theme 190583472421, 2026-08-12.

  Only the product rail needs script. The FAQ uses native details and summary,
  and every other section is static markup and CSS, so the page works with
  JavaScript unavailable.

  This file changes no price, availability, variant, policy or identity value. It
  scrolls a container and enables or disables two buttons.

  Contains no Unicode em dash characters.
*/

(() => {
  'use strict';

  function initRail(rail) {
    if (rail.dataset.oh8Ready === 'true') return;
    rail.dataset.oh8Ready = 'true';

    const track = rail.querySelector('[data-oh8-rail-track]');
    if (!track) return;

    // The buttons live in the section head, outside the rail, so they are found
    // through the section rather than the rail element.
    const scope = rail.closest('.oh8__section') || rail.parentElement;
    const prev = scope && scope.querySelector('[data-oh8-rail-prev]');
    const next = scope && scope.querySelector('[data-oh8-rail-next]');
    if (!prev || !next) return;

    // Advance by whole cards, so a card never ends up half cut at the edge.
    const step = () => {
      const first = track.firstElementChild;
      if (!first) return track.clientWidth;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      const card = first.getBoundingClientRect().width + gap;
      const perView = Math.max(1, Math.floor(track.clientWidth / card));
      return card * perView;
    };

    const sync = () => {
      const max = track.scrollWidth - track.clientWidth;
      // One pixel of tolerance, because scrollLeft is fractional on zoom and on
      // some trackpads it never lands exactly on the maximum.
      prev.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft >= max - 1;
    };

    prev.addEventListener('click', () => {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });

    next.addEventListener('click', () => {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', () => {
      window.requestAnimationFrame(sync);
    }, { passive: true });

    window.addEventListener('resize', sync, { passive: true });
    sync();
  }

  function init(root) {
    (root || document).querySelectorAll('[data-oh8-rail]').forEach(initRail);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target || document));
})();
